module.exports = __webpack_public_path__ + "static/media/tero.toivanen.cc9dad10.jpg";